/* eslint-disable jsx-a11y/anchor-is-valid */
import * as Yup from "yup";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import Swal from 'sweetalert2'
import { axiosInstance } from "../../Axios/https";
import Loader from "../Loader/Loader";

const SignupComponent = () => {
  const [imageUrl, setImageUrl] = useState("");
  const [file, setFile] = useState(null);
  const [imageUrl1, setImageUrl1] = useState("");
  const [file1, setFile1] = useState(null);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFile(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setImageUrl(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleImageRemove = () => {
    setImageUrl("");
    document.getElementById("file-input").value = "";
  };

  const handleImageChange1 = (e) => {
    const file1 = e.target.files[0];
    setFile1(file1);
    const reader = new FileReader();
    reader.onloadend = () => {
      setImageUrl1(reader.result);
    };
    if (file1) {
      reader.readAsDataURL(file1);
    }
  };

  const handleImageRemove1 = () => {
    setImageUrl1("");
    document.getElementById("file-input1").value = "";
  };

  const initialValues = {
    fname: "",
    lname: "",
    email: "",
    password: "",
    petname: "",
    petbreed: "",
    petcolor: "",
    microphone: "",
    address: "",
    telephone: "",
  };
  const initialSchema = Yup.object().shape({
    fname: Yup.string().required("First name is required"),
    lname: Yup.string().required("Last name is required"),
    email: Yup.string().email().required("Email is required"),
    password: Yup.string().required("Password is required"),
    petname: Yup.string().required("Pet name is required"),
    petbreed: Yup.string().required("Pet breed is required"),
    petcolor: Yup.string().required("Pet color is required"),
    microphone: Yup.string().required("Microphone is required"),
    address: Yup.string().required("Address is required"),
    telephone: Yup.string().required("Telephone is required"),
  });

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: initialSchema,
      onSubmit: (values) => {
        setLoader(true);
        if (file && file1) {
          const formData = new FormData();
          formData.append("first_name", values.fname);
          formData.append("last_name", values.lname);
          formData.append("email", values.email);
          formData.append("password", values.password);
          formData.append("pet_name", values.petname);
          formData.append("pet_breed", values.petbreed);
          formData.append("pet_color", values.petcolor);
          formData.append("microchip_no", values.microphone);
          formData.append("address", values.address);
          formData.append("phone", values.telephone);
          formData.append("image[0]", file);
          formData.append("image[1]", file1);
          axiosInstance
            .post("client/registration", formData)
            .then((res) => {
              if (res?.data?.status === true) {
                console.log(res?.data?.data?.id);
                localStorage.setItem("id", res?.data?.data?.id);
                Swal.fire({
                  title: "Stolen",
                  text: res?.data?.message
                    ? res?.data?.message
                    : "Signup Successfully",
                  icon: "success",
                });
                navigate("/verification");
                setLoader(false);
              } else {
                Swal.fire({
                  title: "Stolen",
                  text: res?.data?.message,
                  icon: "error",
                });
                setLoader(false);
              }
            })
            .catch((err) => {
              Swal.fire({
                title: "Stolen",
                text: err?.response?.data?.message,
                icon: "error",
              });
              setLoader(false);
            });
        } else {
          Swal.fire({
            title: "Stolen",
            text: "Please upload your image",
            icon: "error",
          });
          setLoader(false);
        }
      },
    });

  return (
    <>
      <>
        <div className="inner-page-banner">
          <div className="breadcrumb-vec-btm">
            <img
              className="img-fluid"
              src="assets/images/bg/inner-banner-btm-vec.png"
              alt=""
            />
          </div>
          <div className="container">
            <div className="row justify-content-center align-items-center text-center">
              <div className="col-lg-6 align-items-center">
                <div className="banner-content">
                  <h1>Sign Up</h1>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={"/"}>Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Sign Up
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="banner-img d-lg-block d-none">
                  <div className="banner-img-bg">
                    <img
                      className="img-fluid"
                      src="assets/images/bg/inner-banner-vec.png"
                      alt=""
                    />
                  </div>
                  <img
                    className="img-fluid"
                    src="assets/images/bg/inner-banner-img.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="signup-section pt-120 pb-120">
          <div className="container">
            <div className="row d-flex justify-content-center">
              <div className="col-xl-8 col-lg-8 col-md-10">
                <div
                  className="form-wrapper wow fadeInUp"
                  data-wow-duration="1.5s"
                  data-wow-delay=".2s"
                >
                  <div className="form-title">
                    <h3>Sign Up</h3>
                    <p>
                      Do you already have an account?{" "}
                      <Link to={"/login"}>Log in here</Link>
                    </p>
                  </div>
                  <form className="w-100" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-inner">
                          <label>Frist Name *</label>
                          <input
                            type="text"
                            placeholder="Frist Name"
                            name="fname"
                            onChange={handleChange}
                            value={values.fname}
                            onBlur={handleBlur}
                          />
                          {errors.fname && touched.fname ? (
                            <span
                              className="ms-2"
                              style={{ color: "red", fontSize: "16px" }}
                            >
                              {errors.fname}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-inner">
                          <label>Last Name *</label>
                          <input
                            type="text"
                            placeholder="Last Name"
                            name="lname"
                            onChange={handleChange}
                            value={values.lname}
                            onBlur={handleBlur}
                          />
                          {errors.lname && touched.lname ? (
                            <span
                              className="ms-2"
                              style={{ color: "red", fontSize: "16px" }}
                            >
                              {errors.lname}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-inner">
                          <label>Email *</label>
                          <input
                            type="email"
                            name="email"
                            id="password"
                            placeholder="Email"
                            onChange={handleChange}
                            value={values.email}
                            onBlur={handleBlur}
                          />
                          {errors.email && touched.email ? (
                            <span
                              className="ms-2"
                              style={{ color: "red", fontSize: "16px" }}
                            >
                              {errors.email}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-inner">
                          <label>Password *</label>
                          <input
                            type="password"
                            name="password"
                            id="password"
                            placeholder="Password"
                            onChange={handleChange}
                            value={values.password}
                            onBlur={handleBlur}
                          />
                          <i className="bi bi-eye-slash" id="togglePassword" />
                          {errors.password && touched.password ? (
                            <span
                              className="ms-2"
                              style={{ color: "red", fontSize: "16px" }}
                            >
                              {errors.password}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-inner">
                          <label>Pet Name *</label>
                          <input
                            type="text"
                            placeholder="Pet Name"
                            name="petname"
                            onChange={handleChange}
                            value={values.petname}
                            onBlur={handleBlur}
                          />
                          {errors.petname && touched.petname ? (
                            <span
                              className="ms-2"
                              style={{ color: "red", fontSize: "16px" }}
                            >
                              {errors.petname}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-inner">
                          <label>Pet Breed *</label>
                          <input
                            type="text"
                            placeholder="Pet Breed"
                            name="petbreed"
                            onChange={handleChange}
                            value={values.petbreed}
                            onBlur={handleBlur}
                          />
                          {errors.petbreed && touched.petbreed ? (
                            <span
                              className="ms-2"
                              style={{ color: "red", fontSize: "16px" }}
                            >
                              {errors.petbreed}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-inner">
                          <label>Pet Color *</label>
                          <input
                            type="text"
                            placeholder="Pet Color"
                            name="petcolor"
                            onChange={handleChange}
                            value={values.petcolor}
                            onBlur={handleBlur}
                          />
                          {errors.petcolor && touched.petcolor ? (
                            <span
                              className="ms-2"
                              style={{ color: "red", fontSize: "16px" }}
                            >
                              {errors.petcolor}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-inner">
                          <label>Microchip Number *</label>
                          <input
                            type="number"
                            placeholder="Microchip Number"
                            name="microphone"
                            onChange={handleChange}
                            value={values.microphone}
                            onBlur={handleBlur}
                          />
                          {errors.microphone && touched.microphone ? (
                            <span
                              className="ms-2"
                              style={{ color: "red", fontSize: "16px" }}
                            >
                              {errors.microphone}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-inner">
                          <label>Home address *</label>
                          <input
                            type="text"
                            placeholder="Home address"
                            name="address"
                            onChange={handleChange}
                            value={values.address}
                            onBlur={handleBlur}
                          />
                          {errors.address && touched.address ? (
                            <span
                              className="ms-2"
                              style={{ color: "red", fontSize: "16px" }}
                            >
                              {errors.address}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-inner">
                          <label>Telephone number *</label>
                          <input
                            type="number"
                            placeholder="Telephone number"
                            name="telephone"
                            onChange={handleChange}
                            value={values.telephone}
                            onBlur={handleBlur}
                          />
                          {errors.telephone && touched.telephone ? (
                            <span
                              className="ms-2"
                              style={{ color: "red", fontSize: "16px" }}
                            >
                              {errors.telephone}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-12 mb-15 mb-md-20" id="msform">
                        <div className="row">
                          <div className="file-input col-md-6">
                            <input
                              type="file"
                              name="file-input"
                              id="file-input"
                              className="file-input__input d-none"
                              onChange={handleImageChange}
                              accept="image/*"
                            />
                            <label
                              className="file-input__label btn btn-green btn-sm account-btn"
                              htmlFor="file-input"
                            >
                              <svg
                                aria-hidden="true"
                                focusable="false"
                                data-prefix="fas"
                                data-icon="upload"
                                className="svg-inline--fa fa-upload fa-w-16"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                style={{ width: "40px" }}
                              >
                                <path
                                  fill="currentColor"
                                  d="M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                                ></path>
                              </svg>
                              <span className="ms-10">Upload Picture One</span>
                            </label>
                          </div>
                          <div className="file-input col-md-6">
                            <input
                              type="file"
                              name="file-input"
                              id="file-input1"
                              className="file-input__input d-none"
                              onChange={handleImageChange1}
                              accept="image/*"
                            />
                            <label
                              className="file-input__label btn btn-green btn-sm account-btn"
                              htmlFor="file-input1"
                            >
                              <svg
                                aria-hidden="true"
                                focusable="false"
                                data-prefix="fas"
                                data-icon="upload"
                                className="svg-inline--fa fa-upload fa-w-16"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                style={{ width: "40px" }}
                              >
                                <path
                                  fill="currentColor"
                                  d="M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                                ></path>
                              </svg>
                              <span className="ms-10">Upload Picture Two</span>
                            </label>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 d-flex justify-content-center">
                            {imageUrl && (
                              <img
                                src={imageUrl}
                                alt="Preview"
                                style={{
                                  width: "120px",
                                  height: "120px",
                                  borderRadius: "50%",
                                }}
                              />
                            )}
                          </div>
                          <div className="col-md-6 d-flex justify-content-center">
                            {imageUrl1 && (
                              <img
                                src={imageUrl1}
                                alt="Preview"
                                style={{
                                  width: "120px",
                                  height: "120px",
                                  borderRadius: "50%",
                                }}
                              />
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            {imageUrl && (
                              <button
                                className="account-btn"
                                style={{ marginTop: "10px" }}
                                onClick={handleImageRemove}
                              >
                                Remove Image
                              </button>
                            )}
                          </div>
                          <div className="col-md-6">
                            {imageUrl1 && (
                              <button
                                className="account-btn"
                                style={{ marginTop: "10px" }}
                                onClick={handleImageRemove1}
                              >
                                Remove Image
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-agreement form-inner d-flex justify-content-between flex-wrap">
                          <div className="form-group">
                            <input type="checkbox" id="html" />
                            <label htmlFor="html">
                              I agree to the Terms &amp; Policy
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button className="account-btn">
                      {loader ? <Loader /> : "Create Account"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default SignupComponent;
